import { useMemo } from "react";
import { useParams } from "react-router";
import { useAuth } from "@/contexts/auth-context";
import { resolveExtensionComponent } from "@/extensions/registry";
import { Card } from "@/components/ui/card";
import { PageHeader, PageSection } from "@/components/layouts/page-layout";

export function TenantExtensionPage() {
  const { user } = useAuth();
  const { extensionName } = useParams<{ extensionName: string }>();
  const tenant = user?.tenant;

  const extension = useMemo(() => {
    if (!tenant || !extensionName) return null;
    return tenant.extensions.find(
      (item) => item.name === extensionName && item.enabled && item.type === "cms"
    );
  }, [tenant, extensionName]);

  if (!tenant) {
    return (
      <PageSection>
        <Card className="p-4">
          <div className="text-muted-foreground">Loading tenant information...</div>
        </Card>
      </PageSection>
    );
  }

  if (!extension || !extensionName) {
    return (
      <PageSection>
        <Card className="p-4">
          <div className="text-destructive">Extension not found or disabled.</div>
        </Card>
      </PageSection>
    );
  }

  // eslint-disable-next-line react-hooks/static-components
  const ExtensionComponent = resolveExtensionComponent(tenant.slug, extensionName);
  if (!ExtensionComponent) {
    return (
      <>
        <PageHeader
          title={extension.display_name || extension.name}
          description="Extension view"
        />
        <PageSection>
          <Card className="p-4">
            <div className="text-muted-foreground">No component mapping found for this extension.</div>
          </Card>
        </PageSection>
      </>
    );
  }

  return (
    <>
      <PageHeader
        title={extension.display_name || extension.name}
        description="Extension view"
      />
      <PageSection>
        <ExtensionComponent tenantSlug={tenant.slug} extension={extension} />
      </PageSection>
    </>
  );
}
